import { fetchFormatTypes, generateNoteFormat } from '@/features/noteFormats/services/noteFormatService';
import { NoteFormatResponse } from '@/features/noteFormats/types';

const VIBE_CODE_DISPLAY_NAME = 'Vibe Code';

export const getVibeCodePromptId = async (): Promise<string> => {
  const types = await fetchFormatTypes();
  const vibeType = types.find((t) => t.display_name === VIBE_CODE_DISPLAY_NAME);
  if (!vibeType) {
    throw new Error('VIBE_CODE_FORMAT_NOT_FOUND');
  }
  return vibeType.prompt_id;
};

export const generateVibeCodeFormat = async (noteId: string, promptId: string): Promise<NoteFormatResponse> => {
  return generateNoteFormat({ noteId, promptId });
};
